export class NeedsUserInputError extends Error {
  constructor(message = null) {
    super(message)
    this.name = 'NeedsUserInputError'
  }
}
